import { required, schema } from '@angular/forms/signals';

import { FacilityFormValue } from './facility-form.types';

export const FACILITY_FORM_SCHEMA = schema<FacilityFormValue>(schemaPath => {
    required(schemaPath.name, { message: 'Facility name is required.' });
    required(schemaPath.type, { message: 'Facility type is required.' });
    required(schemaPath.addressLine1, { message: 'Address is required.' });
    required(schemaPath.city, { message: 'City is required.' });
    required(schemaPath.state, { message: 'State is required.' });
    required(schemaPath.zipCode, { message: 'Zip code is required.' });
    required(schemaPath.country, { message: 'Country is required.' });
});
